import {Button, NativeSelect, NativeSelectOption} from '@kroll-resolver-crisp/ui-components-react';
import {UNKNOWN_LANGUAGE, type LanguageQueueSummary} from '@/api/moderationQueue';
import {NO_FILTERS, hasFilters, languageLabel, type QueueFilters} from '@/lib/queueFilters';

type Props = {
  readonly filters: QueueFilters;
  readonly languages: readonly LanguageQueueSummary[];
  readonly onChange: (filters: QueueFilters) => void;
};

// Language, with what is available per language. The verticals and classifications are the sidebar's.
export function QueueFilterBar({filters, languages, onChange}: Props) {
  const languageOptions = languages.map((entry) => ({
    value: entry.language ?? UNKNOWN_LANGUAGE,
    label: languageLabel(entry.language),
    count: entry.available
  }));
  if (filters.language && !languageOptions.some((option) => option.value === filters.language)) {
    languageOptions.push({
      value: filters.language,
      label: languageLabel(filters.language === UNKNOWN_LANGUAGE ? null : filters.language),
      count: 0
    });
  }

  return (
    <div className="border-border bg-card flex flex-col gap-2 border-b px-3 py-2">
      <div className="flex flex-wrap items-center gap-3">
        <NativeSelect
          size="sm"
          aria-label="Language"
          value={filters.language ?? ''}
          onChange={(event) => {
            onChange({...filters, language: event.target.value || null});
          }}>
          <NativeSelectOption value="">All languages</NativeSelectOption>
          {languageOptions.map((option) => (
            <NativeSelectOption key={option.value} value={option.value}>
              {option.label} ({option.count})
            </NativeSelectOption>
          ))}
        </NativeSelect>

        {hasFilters(filters) ? (
          <Button
            type="button"
            variant="link"
            size="sm"
            onClick={() => {
              onChange(NO_FILTERS);
            }}>
            Clear all
          </Button>
        ) : null}
      </div>
    </div>
  );
}
